import React from 'react'

const CircleDot = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className='inline-flex' width="2" height="2" viewBox="0 0 2 2" fill="none">
    <circle cx="1" cy="1" r="1" fill="#1E293B" />
  </svg>
  )
}

export default CircleDot